import HeadOpenGraphMeta from './HeadOpenGraphMeta';

export default HeadOpenGraphMeta;
